import {
  AnsweringClient,
  GetManagedInstrumentsSearchParams,
  IInstrument,
} from "../../clients/answeringClient";
import { IAssignment } from "../../UserManagement/types";

export interface CreateGroupModalControllerDelegate {
  didGetAssignments: (assignments: IAssignment[]) => void;
  didCreateGroup: (createdId: number) => void;
  applicationShouldLogout: () => void;
  genericError: (s?: string) => void;
}

export class CreateGroupModalController {
  constructor(
    private delegate: CreateGroupModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async getManagedAssignments(accessToken: string) {
    try {
      const response = await this.answeringClient.getManagedAssignments(
        accessToken
      );
      this.delegate.didGetAssignments(response.data.data);
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) return;
        this.getManagedAssignments(newTokens.accessToken);
        return;
      }
      this.delegate.genericError();
    }
  }

  public async createGroup(
    accessToken: string,
    name: string,
    appIds: number[],
    description?: string
  ) {
    let createdGroupId: number | null = null;
    try {
      const result = await this.answeringClient.createGroup(
        accessToken,
        name,
        description
      );
      createdGroupId = (result.data as { created: number }).created;
      if (appIds.length)
        await this.answeringClient.addAppsToGroup(
          accessToken,
          appIds,
          createdGroupId
        );
      this.delegate.didCreateGroup(createdGroupId);
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) return;
        this.createGroup(newTokens.accessToken, name, appIds, description);
        return;
      } else if (!createdGroupId)
        return this.delegate.genericError("Erro ao criar o grupo!");
      return this.delegate.genericError(
        "Erro ao adicionar aplicações ao grupo"
      );
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }

  public async getAvailableInstruments(
    token: string,
    params: GetManagedInstrumentsSearchParams
  ): Promise<IInstrument[]> {
    const resp = await this.answeringClient.getManagedInstrumentsSearch(token, params);
    return resp.data.data;
  }
}
